export default __webpack_public_path__ + "static/media/copilot-column.652adf2c.svg";